'use strict';

var assign = require('object-assign');

var logger	= require('../../utils/logger.js');

var FluxChangeStore	= require('./flux-change-store.js');
var FluxConstants 	= require('../constants/flux-constants.js');
var FluxDispatcher 	= require('../dispatchers/flux-dispatcher.js');
var Constants 		= require('../constants/tips-search-constants.js');

var ActionTypes 	= Constants.ActionTypes;
var PayloadSources 	= FluxConstants.PayloadSources;

var storeData = {
	authorItems: [],
	baseSearchContext: null,
	isLoading: true,
	navigatedAuthor: null,
	searchContext: null,
	searchResultsUrl: null,
	searchTerm: null,
	totalResults: 0,
};

var store = assign(new FluxChangeStore(), {
	getState: function () {
		return storeData;
	}
});

function handleServerAction(action) {
	if (action) {
		var handled = false;

		switch(action.type) {
			case ActionTypes.TIPS_SEARCH_LOAD_DATA_SUCCESS:
				handled = true;
				storeData = assign({}, action.data, {
					isLoading: false
				});

				break;
			case ActionTypes.TIPS_SEARCH_LOAD_DATA_ERROR:
				handled = true;
				storeData.isLoading = false;
				// TODO: render error message

				break;
			default:
				// do nothing
		}

		if (handled) {
			logger.debug({
				store: 'News Search',
				message: 'Handle server action',
				action: action.type,
				data: action.data
			});

			store.emitChange();
		}
	}
}

function handleViewAction(action) {
	if (action) {
		var handled = false;

		switch(action.type) {
			case ActionTypes.TIPS_SEARCH_UPDATE_FILTERS:
				handled = true;
				storeData.isLoading = true;

				break;
			default:
				// do nothing
		}

		if (handled) {
			logger.debug({
				store: 'News Search',
				message: 'Handle view action',
				action: action.type,
				data: action.data
			});

			store.emitChange();
		}
	}
}

store.dispatchToken = FluxDispatcher.register(function (payload) {
	if (payload && payload.source) {
		if (payload.source === PayloadSources.SERVER_ACTION) {
			handleServerAction(payload.action);
		} else if (payload.source === PayloadSources.VIEW_ACTION) {
			handleViewAction(payload.action);
		}
	}
});

module.exports = store;